import type { ApprovalChain } from './approval-chain.model';
import { BOND_CANCELLATION_CHAIN } from './chains/bond-cancellation.chain';
import { BOND_REGISTRATION_CHAIN } from './chains/bond-registration.chain';
import { DEED_OF_GRANT_BOND_CHAIN } from './chains/deed-of-grant-bond.chain';
import { DEED_OF_GRANT_CHAIN } from './chains/deed-of-grant.chain';
import { DEED_RE_ISSUANCE_CHAIN } from './chains/deed-re-issuance.chain';
import { DEED_SUBDIVISION_CHAIN } from './chains/deed-subdivision.chain';
import { DEED_TRANSFER_CHAIN } from './chains/deed-transfer.chain';
import { LAND_TENURE_DEED_OF_GRANT_CHAIN } from './chains/land-tenure-deed-of-grant.chain';
import { LAND_TENURE_SUBDIVISION_CHAIN } from './chains/land-tenure-subdivision.chain';
import { LAND_TENURE_TRANSFER_CHAIN } from './chains/land-tenure-transfer.chain';
import { NOTARIAL_DEED_SECTION_CHAIN } from './chains/notarial-deed-section.chain';
import { RECTIFICATION_CHAIN } from './chains/rectification.chain';
import { TRUST_REGISTRATION_CHAIN } from './chains/trust-registration.chain';
import { CAVEAT_REGISTRATION_CHAIN } from './chains/caveat-registration.chain';
import { CAVEAT_UPLIFT_CHAIN } from './chains/caveat-uplift.chain';
import { LEASE_CANCELLATION_CHAIN } from './chains/lease-cancellation.chain';
import { NOTE_OF_HAND_CHAIN } from './chains/note-of-hand.chain';
import { DEED_DONATION_TRANSFER_CHAIN } from './chains/deed-donation-transfer.chain';
import { DEED_DONATION_TRANSFER_BOND_CHAIN } from './chains/deed-donation-transfer-bond.chain';
import { DEED_CONSOLIDATION_CHAIN } from './chains/deed-consolidation.chain';
import { SECTIONAL_TITLE_CHAIN } from './chains/sectional-title.chain';
import { LAND_TENURE_SECTIONAL_TITLE_CHAIN } from './chains/land-tenure-sectional-title.chain';
import { DEED_ESTATE_TRANSFER_CHAIN } from './chains/deed-estate-transfer.chain';
import { DEED_ESTATE_TRANSFER_BOND_CHAIN } from './chains/deed-estate-transfer-bond.chain';
import { LAND_TENURE_NOTARIAL_DEED_SECTION_CHAIN } from './chains/land-tenure-notarial-deed-section.chain';
import { DEED_TRANSFER_BOND_CHAIN } from './chains/deed-transfer-bond.chain';
import { LAND_TENURE_TRANSFER_BOND_CHAIN } from './chains/land-tenure-transfer-bond.chain';
import { LAND_TENURE_SUBDIVISION_BOND_CHAIN } from './chains/land-tenure-subdivision-bond.chain';
import { DEED_SUBDIVISION_BOND_CHAIN } from './chains/deed-subdivision-bond.chain';
import { DEED_RE_ISSUANCE_BOND_CHAIN } from './chains/deed-re-issuance-bond.chain';
import { MORTGAGE_DEED_OF_GRANT_CHAIN } from './chains/mortgage-deed-of-grant.chain';
import { XN_CAVEAT_REGISTRATION_CHAIN } from './chains/xn-caveat-registration.chain';

export * from './approval-chain.model';

export {
  MORTGAGE_DEED_OF_GRANT_CHAIN,
  XN_CAVEAT_REGISTRATION_CHAIN,
  CAVEAT_REGISTRATION_CHAIN,
  CAVEAT_UPLIFT_CHAIN,
  LEASE_CANCELLATION_CHAIN,
  NOTE_OF_HAND_CHAIN,
  DEED_DONATION_TRANSFER_CHAIN,
  DEED_DONATION_TRANSFER_BOND_CHAIN,
  DEED_CONSOLIDATION_CHAIN,
  SECTIONAL_TITLE_CHAIN,
  LAND_TENURE_SECTIONAL_TITLE_CHAIN,
  DEED_ESTATE_TRANSFER_CHAIN,
  DEED_ESTATE_TRANSFER_BOND_CHAIN,
  LAND_TENURE_NOTARIAL_DEED_SECTION_CHAIN,
  DEED_TRANSFER_BOND_CHAIN,
  LAND_TENURE_TRANSFER_BOND_CHAIN,
  LAND_TENURE_SUBDIVISION_BOND_CHAIN,
  DEED_SUBDIVISION_BOND_CHAIN,
  DEED_RE_ISSUANCE_BOND_CHAIN,
  BOND_CANCELLATION_CHAIN,
  BOND_REGISTRATION_CHAIN,
  DEED_OF_GRANT_BOND_CHAIN,
  DEED_OF_GRANT_CHAIN,
  DEED_RE_ISSUANCE_CHAIN,
  DEED_SUBDIVISION_CHAIN,
  DEED_TRANSFER_CHAIN,
  LAND_TENURE_DEED_OF_GRANT_CHAIN,
  LAND_TENURE_SUBDIVISION_CHAIN,
  LAND_TENURE_TRANSFER_CHAIN,
  NOTARIAL_DEED_SECTION_CHAIN,
  RECTIFICATION_CHAIN,
  TRUST_REGISTRATION_CHAIN,
};

export const APPROVAL_CHAINS: ApprovalChain[] = [
  DEED_OF_GRANT_CHAIN,
  DEED_OF_GRANT_BOND_CHAIN,
  LAND_TENURE_DEED_OF_GRANT_CHAIN,
  DEED_TRANSFER_CHAIN,
  DEED_SUBDIVISION_CHAIN,
  LAND_TENURE_TRANSFER_CHAIN,
  LAND_TENURE_SUBDIVISION_CHAIN,
  DEED_RE_ISSUANCE_CHAIN,
  BOND_REGISTRATION_CHAIN,
  BOND_CANCELLATION_CHAIN,
  NOTARIAL_DEED_SECTION_CHAIN,
  TRUST_REGISTRATION_CHAIN,
  RECTIFICATION_CHAIN,
  CAVEAT_REGISTRATION_CHAIN,
  CAVEAT_UPLIFT_CHAIN,
  LEASE_CANCELLATION_CHAIN,
  NOTE_OF_HAND_CHAIN,
  DEED_DONATION_TRANSFER_CHAIN,
  DEED_DONATION_TRANSFER_BOND_CHAIN,
  DEED_CONSOLIDATION_CHAIN,
  SECTIONAL_TITLE_CHAIN,
  LAND_TENURE_SECTIONAL_TITLE_CHAIN,
  DEED_ESTATE_TRANSFER_CHAIN,
  DEED_ESTATE_TRANSFER_BOND_CHAIN,
  LAND_TENURE_NOTARIAL_DEED_SECTION_CHAIN,
  DEED_TRANSFER_BOND_CHAIN,
  LAND_TENURE_TRANSFER_BOND_CHAIN,
  LAND_TENURE_SUBDIVISION_BOND_CHAIN,
  DEED_SUBDIVISION_BOND_CHAIN,
  DEED_RE_ISSUANCE_BOND_CHAIN,
  MORTGAGE_DEED_OF_GRANT_CHAIN,
  XN_CAVEAT_REGISTRATION_CHAIN,
];
